import React from "react";
import Hero from "@/components/Hero";
import YouTubeGallery from "@/components/YouTubeGallery";
import NewspaperSection from "@/components/NewspaperSection";
import SocialFeed from "@/components/SocialFeed";
import MerchPreview from "@/components/MerchPreview";
import CommentSection from "@/components/CommentSection";
import BrandMovement from "@/components/BrandMovement";
import AboutBanner from "@/components/AboutBanner";
import SponsorsBar from "@/components/SponsorsBar";
import ScheduleSection from "@/components/ScheduleSection";
import NewsletterSignup from "@/components/NewsletterSignup";
import BannerHeader from "@/components/BannerHeader";
import MyTeamsScores from "@/components/MyTeamsScores";

export default function Home() {
  return (
    <div data-testid="home-page">
      <BannerHeader />
      <AboutBanner />
      <SponsorsBar />
      <Hero />
      <MyTeamsScores />
      <ScheduleSection />
      <YouTubeGallery limit={3} />
      <NewspaperSection />
      <MerchPreview limit={4} />
      <SocialFeed />
      <NewsletterSignup />
      <CommentSection targetType="general" targetId="home-feed" title="Fan Section" />
    </div>
  );
}
